// Copyright 2026 The Simlin Authors. All rights reserved.
// Use of this source code is governed by the Apache License,
// Version 2.0, that can be found in the LICENSE file.

import * as React from 'react';

// Systems Analyzer loop-mark (Williams 2026-08-08): a two-arc feedback loop
// with a yin/yang "harmony" hub, brand navy (#0B1829) + cyan (#0891B2). Mirrors
// logo-mark.svg / the favicon so the drawer, Login, and browser tab all show the
// same mark.
//
// Each instance mints unique arrowhead-marker ids: SVG `url(#id)` references
// resolve document-wide, so two ModelIcons sharing an id would both bind to
// whichever marker is first in the DOM -- and the second would break if the
// first unmounts (e.g. the drawer closes while Login is still up). A module
// counter keeps ids stable and unique per instance without Date.now()/random.
let modelIconSeq = 0;

export class ModelIcon extends React.PureComponent<{ className?: string }> {
  private readonly cyanHeadId = `sa-mark-ahc-${(modelIconSeq += 1)}`;
  private readonly navyHeadId = `sa-mark-ahn-${modelIconSeq}`;

  render() {
    const { className } = this.props;
    const { cyanHeadId, navyHeadId } = this;

    return (
      <svg viewBox="0 0 88 88" className={className} role="img" aria-label="Systems Analyzer">
        <defs>
          <marker
            id={cyanHeadId}
            markerUnits="userSpaceOnUse"
            markerWidth="13"
            markerHeight="12"
            refX="0"
            refY="6"
            orient="auto"
          >
            <path d="M0,0 L12,6 L0,12 Z" fill="#0891B2" />
          </marker>
          <marker
            id={navyHeadId}
            markerUnits="userSpaceOnUse"
            markerWidth="13"
            markerHeight="12"
            refX="0"
            refY="6"
            orient="auto"
          >
            <path d="M0,0 L12,6 L0,12 Z" fill="#0B1829" />
          </marker>
        </defs>
        <g>
          <path
            d="M63.28,21.02 A30,30 0 0 1 40.86,73.84"
            fill="none"
            stroke="#0891B2"
            strokeWidth="7"
            strokeLinecap="butt"
            markerEnd={`url(#${cyanHeadId})`}
          />
          <path
            d="M24.72,66.98 A30,30 0 0 1 47.14,14.16"
            fill="none"
            stroke="#0B1829"
            strokeWidth="7"
            strokeLinecap="butt"
            markerEnd={`url(#${navyHeadId})`}
          />
          <g transform="rotate(30 44 44)">
            <circle cx="44" cy="44" r="6.5" fill="#0891B2" />
            <path
              d="M44,37.5 a6.5,6.5 0 0 1 0,13 a3.25,3.25 0 0 1 0,-6.5 a3.25,3.25 0 0 0 0,-6.5 z"
              fill="#0B1829"
            />
            <circle cx="44" cy="40.75" r="1.5" fill="#0891B2" />
            <circle cx="44" cy="47.25" r="1.5" fill="#0B1829" />
          </g>
        </g>
      </svg>
    );
  }
}
